import { render, staticRenderFns } from "./CouponPreview.vue?vue&type=template&id=fc5791e4&scoped=true&"
import script from "./CouponPreview.vue?vue&type=script&lang=js&"
export * from "./CouponPreview.vue?vue&type=script&lang=js&"
import style0 from "./CouponPreview.vue?vue&type=style&index=0&id=fc5791e4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc5791e4",
  null
  
)

export default component.exports